module.exports = __webpack_public_path__ + "img/gallery.322d1749.png";